import { useRef } from 'react';
import { Group } from 'three';

import IndicationRingsScene from '../IndicationRingsScene/IndicationRingsScene';

import useRaycast from 'hooks/useRaycast';

const OverAddresScene = () => {
  const overAddressSceneRef = useRef<Group>(null);

  useRaycast(
    position => overAddressSceneRef.current?.position.copy(position),
    {}
  );

  return (
    <group ref={overAddressSceneRef}>
      <IndicationRingsScene />
    </group>
  );
};

export default OverAddresScene;
